import { Link, useLocation } from "react-router-dom";

type Props = {
  activeSection?: string;
};

const labelMap: Record<string, string> = {
  home: "Home",
  about: "About",
  innovation: "Innovation",
  blog: "Blog",
  testimony: "Testimony",
  contact: "Contact",
};

const Breadcrumbs = ({ activeSection }: Props) => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  if (isHome) {
    return (
      <span className="text-sm text-text-secondary">
        Home
        {activeSection && activeSection !== "home" && (
          <>
            {" / "}
            <span className="text-primary">
              {labelMap[activeSection] ?? activeSection}
            </span>
          </>
        )}
      </span>
    );
  }

  return (
    <nav className="text-sm text-text-secondary flex gap-2">
      <Link to="/" className="hover:text-primary">
        Home
      </Link>
      <span>/</span>
      <span className="text-primary capitalize">
        {location.pathname.replace("/", "")}
      </span>
    </nav>
  );
};

export default Breadcrumbs;